import React, { useEffect, useState } from "react";
import BackdropScI from "../../services/BackdropScI";
import { premiA } from "../../Context/InshData";
import axios from "axios";
import Container from "@material-ui/core/Container";
import { Apis } from "../../help/Apis";
import MenusContRef from "../Menues/MenusContRef";
import { getLS } from "../../utils/useLS";
import POSDashboardCon from "../../comps/Dashboard/POSDashboardCon";
import { GetItemFromOptions } from "../../services/global-services";
import { useHistory } from "react-router-dom";
import moment from "moment";
import RePay from "../../Start/RePay";
import SubScriptionEndingAlert from "../../subscriptionAlert";
import MainNew from "./MainNew";


export function isExpiredAnull(startDate, endDate) {
  if (!startDate) return true;
    // إذا كانت القيمة Date بالفعل
    if (startDate instanceof Date) {
        return isNaN(startDate.getTime()) ? null : startDate;
    }

    const str = String(startDate).trim();
    if (!str) return null;
    let year, month, day;

    // الصيغة: yyyy-MM-dd أو yyyy/MM/dd
    let match = str.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);

    if (match) {
        year = Number(match[1]);
        month = Number(match[2]);
        day = Number(match[3]);
    } else {
        // الصيغة: dd/MM/yyyy أو dd-MM-yyyy
        match = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
        if (!match) return null;

        day = Number(match[1]);
        month = Number(match[2]);
        year = Number(match[3]);
    }
    // إنشاء التاريخ والتحقق من صحته
    const date = new Date(year, month - 1, day);
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return null;
    }
    let sdate = moment(new Date());
    const daysTotal = sdate.diff(date, 'days');
    return daysTotal >= 370;
};

export default function MainScreen(props) {
  // const { isFromLgin } = props;
  // const loc = useLocation();
  const [permiApp, setPermiApp] = useState({});
  const [showSc, setShowSc] = useState(true);
  const [Users, setUsers] = useState([]);
  const [userData, setUserData] = useState({ id: 0, name: "0" });
  const [found, setFound] = useState({});



  let pScr = getLS("premiScr", {});
  const [uris, setUris] = useState({ uri: "http://localhost:8184/" });
  const [salePointOnly, setSalePointOnly] = useState(
    pScr?.salePointOnly ?? false
  );


  const getUPrmi = async (urisp, stos) => {
    setUserData({ id: stos.idi, name: stos.usernames });
    const tb = {
      wait: true,
      UsersA: true,
      GetFoundation: true,
      parms: {
        iuserid: stos.idi,
        ibranchid: stos.branchi,
        iempid: stos.empi,
        branch: stos.branchi,
        iFoundid: 1,
        tname: "FromMain",
        db_name: stos.db_name,
      },

    };

    await axios
      .post(urisp + `Res`, tb)
      .then((res) => {
        console.log("__res__");
        console.log("__res__");
        let loc = getLS("premiApp", {});
        setUsers(res?.data?.Users);
        setFound(res?.data?.Found);
        // console.log(" the  __users__ is", res?.data?.Users);
        // console.log(" def  __users__ is", stos);
        // console.log("loc");
        // console.log(loc);
        // console.log("Maiiiiiiin");
        // alert('stop')
        setPermiApp(loc);
        setShowSc(res.data.wait.state);
        console.log("__res__");
      })
      .catch((error) => { });
  };

  useEffect(() => {
    console.log("premia", premiA);
    const urisR = Apis();
    let loc = getLS("DataRem", {});
    setUris(urisR);
    getUPrmi(urisR, loc);
  }, []);

  //----------------------------------------------------------------
  const locConn = JSON.parse(localStorage.getItem("infoConn")) || {};

  const inshState = {
    server: locConn.server,
    ipinsh: locConn.ipinsh,
    changip: locConn.changip,
    ip: locConn.ip,
    endDigtip: locConn.endDigtip,
    namedb: locConn.namedb,
    id: locConn.id,
    pass: locConn.pass,
    useUri: locConn.useUri,
    port: locConn.port,
    ftp: locConn.ftp,
    typeConnct: locConn.typeConnct,
    mode: locConn.mode,
    leavle: "signIn",
  };

  const refDatas_out = () => {
    localStorage.removeItem("dataShamel");
    let loc = JSON.parse(localStorage.getItem("premiApp"));

    localStorage.setItem("premiApp", JSON.stringify({ ...loc, id: 0 }));
    localStorage.removeItem("DataRem");
  };
  let his = useHistory();

  function refreshPage() {
    his.push({ pathname: "/" });
    window.location.reload(false);
  }

  const singout = () => {
    refDatas_out();
    console.log("swipeable infoconn")
    localStorage.setItem("infoConn", JSON.stringify(inshState));
    refreshPage();
  };
  const DefUsers = Users ? Users : [];
  const valueUsers = GetItemFromOptions(userData?.id, DefUsers);

  useEffect(() => {
    if (valueUsers?.name == null || valueUsers?.name == "") return;
    if (userData?.name != valueUsers?.name) {
      singout();
    };
  }, [Users, userData]);

  //--------------------------------------------------------------------
  return showSc ? (
    <BackdropScI />
  ) : (
    <React.Fragment >
      {/* <CssBaseline /> */}
      <SubScriptionEndingAlert startDate={found?.StartWorkDate ?? null} endDate={found?.EndWorkDate ?? null} />

      {isExpiredAnull(found?.StartWorkDate ?? null, found?.EndWorkDate ?? null) ?
        (
          <RePay singout={singout} />
        ) : premiA.menuMin != undefined && premiA.id != 0 ? (
          // <React.Fragment>
          <>
            {salePointOnly ? (
              <POSDashboardCon found={found} />
            ) : (
              <>
                <MainNew found={found} />
                {/* <MainDashboard found={found}/> */}

              </>
            )}
          </>
        ) : (
          <Container
            maxWidth="lg"
            style={{
              backgroundColor: "#fff",
              height: "100vh",
              paddingTop: "30vh",
            }}
          >
            <MenusContRef />

          </Container>
        )}
    </React.Fragment>
  );
}
